import store from "@/store"
import {jumpPassport ,jumpHome} from '@/utils/url_redirection'
import {generateRedirect} from '@/utils/skip'

export default { 
     bind(el, binding, vnode) {
        // 1. 创建遮罩层元素
        const mask = document.createElement('div')
        // 可选：添加提示文字或图标
        mask.innerHTML = `
            <div style="
                display:flex;
                align-items:center;
                justify-content:center;
                width:100%;
                height:100%;
                position:absolute;
                top:50%;
                left:50%;
                transform:translate(-50%,-50%);
                color:#ED1D24;
                background-color:rgba(255, 255, 255, 0.4);
                backdrop-filter: blur(10px);
                -webkit-backdrop-filter: blur(10px); /* 兼容 Safari */
                font-size:16px;
            "> 
                <div class="linkHoverLine loginMask" style="cursor: pointer">登录后查看完整信息</div>
            </div>
        `
        // 【新增】获取内部可点击的元素并绑定跳转逻辑
        const loginTextEl = mask.querySelector('.linkHoverLine')
        if (loginTextEl) {
            loginTextEl.addEventListener('click', (e) => {
                // 阻止冒泡，防止触发其他不必要的逻辑
                e.stopPropagation()
                // 跳转到百度
                window.location.href = generateRedirect('/login','/')
                // `${jumpPassport()}/login?clientId=zhuzaobao&redirectUri=${jumpHome()}/index`

            })
        }
        // 2. 将遮罩层添加到目标元素中
        // 确保父元素有定位属性 (relative/absolute/fixed)，否则遮罩可能位置不对
        if (getComputedStyle(el).position === 'static') {
            el.style.position = 'relative'
        }
        el.appendChild(mask)
        el._maskEl = mask // 将遮罩元素挂载到 el 上，方便后续卸载或更新

        // 3. 定义更新遮罩状态的函数
        const updateMask = () => {
            const isLogin = store.getters.isLogin
            
            // 【核心功能】：如果 binding.value 是一个函数，则调用它并传入布尔值
            if (typeof binding.value === 'function') {
                binding.value(isLogin)
            }
            if (!isLogin) {
                mask.style.display = 'block'
                // 阻止点击穿透（除了我们刚才绑定了跳转的那个文字外，其他区域点击无效）
                mask.addEventListener('click', stopProp, true)
            } else {
                mask.style.display = 'none'
                mask.removeEventListener('click', stopProp, true)
            }
        }

        // 阻止事件冒泡的辅助函数
        const stopProp = (e) => {
            // 注意：由于我们在上面单独给 .linkHoverLine 绑定了 click，
            // 这里的 stopPropagation 会阻止点击背景时触发底层元素事件，
            // 但不会阻止 .linkHoverLine 内部的事件，因为内部事件先触发或通过 e.target 判断会更严谨。
            // 简单的做法是：如果点击的是 linkHoverLine，就不阻止默认行为（虽然 href 跳转不需要 preventDefault）
            
            // 更严谨的写法：
            if (!e.target.classList.contains('linkHoverLine')) {
                e.stopPropagation()
                e.preventDefault()
            }
        }

        // 4. 初始检查
        updateMask()

        // 5. 挂载更新函数
        el._updateMask = updateMask
        el._stopProp = stopProp
    },
    update(el, binding, vnode) {
        if (el._updateMask) {
            el._updateMask()
        }
    },
    unbind(el) {
        if (el._maskEl && el._maskEl.parentNode) {
            el._maskEl.parentNode.removeChild(el._maskEl)
        }
        // 清理事件监听器防止内存泄漏
        if (el._stopProp) {
            el._maskEl?.removeEventListener('click', el._stopProp, true)
        }
        delete el._maskEl
        delete el._updateMask
        delete el._stopProp
    }
}